import React from "react";
import { WEInfoGS } from "../card/WorkedExampleInfo";
import { Typography } from "@mui/material";

const ListInGS = ({ id, list = [], buttons, maxHeight = '100px' }) => {
  const onStopPropagation = (e) => {
    e.stopPropagation();
  };
  return (
    <>
      {list.length > 0 ? (
        <div className="flex flex-col gap-1 w-full" onClick={onStopPropagation}>
          {list.map((example) => (
            <div
              key={`${id}-item-evidence-of-learning-${example._id}`}
              className="rounded bg-loading"
            >
              <WEInfoGS
                key={example._id}
                row={example}
                maxHeight={maxHeight}
                buttons={buttons ? buttons(example) : null}
              />
            </div>
          ))}
        </div>
      ) : <Typography className="text-xs italic bg-loading text-muted-foreground py-2 opacity-50">No items available.</Typography>}
    </>
  );
};

export default ListInGS;
